<div class="platform-view-component" *ngIf="domain?.id">
    <div>Domain: {{domain.full}}</div>
    <app-edit-email-template [emailTemplateId]="emailTemplate.id"></app-edit-email-template>
</div>
